module.exports = __webpack_public_path__ + "static/img/cjx05.412bb98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx05.png
// module id = 163
// module chunks = 0